import { render, staticRenderFns } from "./SettingsSalary.vue?vue&type=template&id=3a3d0532&scoped=true&"
import script from "./SettingsSalary.vue?vue&type=script&lang=js&"
export * from "./SettingsSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3d0532",
  null
  
)

export default component.exports